import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { startSetProfile } from '../../actions/webmaster';

class HomePage extends Component {
  render() {
    return <Redirect to="/dashboard" />;
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.webmaster.isAuthenticated,
});

const mapDispatchToProps = dispatch => ({
  startGetProfile: () => dispatch(startSetProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomePage);
